import { useEffect, useState } from 'react';
import { alpha, Badge, Fab, Grid2 } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import ChatBotPanel from './ChatBotPanel';
import LiveChatPanel from './LiveChatPanel';
import { useAuth } from '../../../hooks/useAuth';
import socket from '../../../utils/socket';
import api from '../../../utils/axios';

export type TChatPanel = 'chatbot' | 'livechat'

const ChatFab = () => {
    const { user, userLoaded } = useAuth()
    const [showFab, setShowFab] = useState(false)
    const [openChat, setOpenChat] = useState(false);
    const [panel, setPanel] = useState<TChatPanel>('chatbot')
    const [unreadCount, setUnreadCount] = useState(0)

    useEffect(() => {
        if (!userLoaded) return;
        if (!user || user.role === 'customer') setShowFab(true)
        if (user && user.role === 'customer') {
            fetchUnreadCount()
            socket.on("live_chat_messages_changed", fetchUnreadCount);
            return () => {
                socket.off("live_chat_messages_changed", fetchUnreadCount);
            }
        }
    }, [user, userLoaded])

    useEffect(() => {
        if (unreadCount > 0 && panel !== 'livechat') setPanel('livechat')
    }, [unreadCount])

    const fetchUnreadCount = () => {
        api.get('/livechat/messages/unread').then(res => setUnreadCount(res.data.count)).catch(console.error)
    }

    const toggleChat = () => setOpenChat(v => !v);

    const switchPanel = (panel: TChatPanel) => setPanel(panel)

    if (!showFab) return null;

    return (
        <>
            <Fab
                color="primary"
                onClick={toggleChat}
                sx={{
                    position: 'fixed',
                    bottom: 16,
                    right: 16,
                    zIndex: 1000,
                }}
            >
                <Badge badgeContent={unreadCount} color="error" overlap='circular'>
                    <ChatIcon />
                </Badge>
            </Fab>

            <Grid2
                display={openChat ? 'flex' : 'none'}
                container
                direction="column"
                spacing={2}
                sx={(theme) => ({
                    position: 'fixed',
                    bottom: 80,
                    right: 16,
                    width: 350,
                    height: '40vh',
                    minHeight: 300,
                    zIndex: 1000,
                    boxShadow: 3,
                    borderRadius: 4,
                    overflow: 'hidden',
                    background: alpha(theme.palette.primary.dark, 0.7),
                    backdropFilter: "blur(5px)",
                    WebkitBackdropFilter: "blur(5px)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                })}
            >
                {openChat && panel === 'chatbot' && <ChatBotPanel switchPanel={switchPanel} />}
                {openChat && panel === 'livechat' && <LiveChatPanel switchPanel={switchPanel} unreadCount={unreadCount} />}
            </Grid2>
        </>
    );
};

export default ChatFab;
